
export type SyncActionType = 
  | 'show'           // Mostrar elemento
  | 'hide'           // Ocultar elemento  
  | 'setText'        // Alterar texto
  | 'setStyle'       // Alterar CSS
  | 'addClass'       // Adicionar classe
  | 'removeClass'    // Remover classe
  | 'openPopup'      // Abrir popup HostVSL
  | 'triggerFunnel'  // Disparar funil dinâmico
  | 'enableButton'   // Ativar botão
  | 'loadBlock';     // Carregar bloco HTML

export interface SyncAction {
  id: string;                    // nanoid
  name: string;                  // Nome descritivo da ação
  time: number;                  // Tempo em segundos
  type: SyncActionType;          // Tipo de ação
  selector: string;              // CSS selector (#id, .class, etc)
  
  // Opções específicas por tipo
  value?: string;                // Texto ou HTML para setText/loadBlock
  property?: string;             // Propriedade CSS para setStyle
  styleValue?: string;           // Valor do estilo
  className?: string;            // Nome da classe para addClass/removeClass
  popupId?: string;              // ID do popup para openPopup
  funnelStep?: number;           // Etapa do funil para triggerFunnel
  
  // Configurações adicionais
  enabled: boolean;              // Ação ativa/inativa
  delay?: number;                // Delay adicional em ms após o tempo
  animation?: {
    type: 'fade' | 'slide' | 'zoom' | 'none';
    duration: number;            // ms
  };
  
  // Metadados
  executed?: boolean;            // Controle interno de execução
  createdAt: string;
  updatedAt: string;
}

export interface SyncActionsConfig {
  enabled: boolean;
  actions: SyncAction[];
  
  // Configurações globais
  previewMode?: boolean;         // Força execução no preview
  debugMode?: boolean;           // Logs detalhados no console
  errorHandling?: 'silent' | 'warn' | 'error';
}

export const defaultSyncActionsConfig: SyncActionsConfig = {
  enabled: false,
  actions: [],
  previewMode: false,
  debugMode: false,
  errorHandling: 'warn'
};
